// Checkbox selection statuses
export const SINGLESELECTION = 'single';
export const PARTIALSELECTION = 'partial';
export const COMPLETESELECTION = 'full';
